import type { ReactElement } from 'react';
import './OpenMessagesCta.css';

interface OpenMessagesCtaProps {
  /** sms:/mailto: deep link back to the Messages thread. */
  href: string;
  title?: string;
  subtitle?: string;
  className?: string;
}

/**
 * Green "Open Messages" handoff card — the same iOS-SMS-bubble styling the
 * onboarding sheet uses for its carrier handoff, factored out so the intake
 * and legal-review "back to your thread" CTAs share one canonical look.
 */
export function OpenMessagesCta({
  href,
  title = 'Open Messages',
  subtitle = 'Message is already drafted',
  className,
}: OpenMessagesCtaProps): ReactElement {
  return (
    <a className={`open-messages-cta${className ? ` ${className}` : ''}`} href={href}>
      <span className="open-messages-cta-icon" aria-hidden>
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
          <path d="M12 2C6.48 2 2 5.97 2 10.5c0 2.39 1.27 4.54 3.31 6.05-.13.95-.62 2.4-1.79 3.79-.21.24-.05.61.27.58 2.3-.21 4.18-.97 5.43-1.7 0.92.18 1.86.28 2.78.28 5.52 0 10-3.97 10-8.5S17.52 2 12 2z" />
        </svg>
      </span>
      <span className="open-messages-cta-label">
        <span className="open-messages-cta-title">{title}</span>
        {subtitle ? <span className="open-messages-cta-sub">{subtitle}</span> : null}
      </span>
      <span className="open-messages-cta-arrow" aria-hidden>→</span>
    </a>
  );
}
